import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VehicleData } from '../models/vehicle.model';
import { environment } from '../../environments/environment';
import { RestProvider } from './rest.service';
import { IQueryParameters } from '../models/api-base-actions.interface';

@Injectable({
  providedIn: 'root'
})
export class VehicleDataService {
  // Mock data
  private vehicleData: VehicleData[] = [
    { date: '31.07.24', vehicleCount: 20, depot: 'DPD Dartford', region: 'Region 1' },
    { date: '30.07.24', vehicleCount: 18, depot: 'DPD Guildford', region: 'Region 1' },
    { date: '29.07.24', vehicleCount: 15, depot: 'DPD Stoke', region: 'Region 1' },
    { date: '28.07.24', vehicleCount: 12, depot: 'DPD Bristol', region: 'Region 3' },
    { date: '27.07.24', vehicleCount: 10, depot: 'DPD Stoke', region: 'Region 1' },
    { date: '26.07.24', vehicleCount: 6, depot: 'DPD Manchester', region: 'Region 2' },
    { date: '25.07.24', vehicleCount: 5, depot: 'DPD Manchester', region: 'Region 2' },
  ];


  private baseApiUrl = environment.dataliveApiUrl;

  constructor(private rest: RestProvider){}

  // getVehicleData(): Observable<VehicleData[]> {
  //   return of(this.vehicleData);
  // }

  getVehicleData(_queryParams?: IQueryParameters){

    return this.rest.get<any>(`${this.baseApiUrl}/utilization/depot_utilization_statistics/`, _queryParams)
  }




}
